define.alias("ember-cli-string-helpers/helpers/lowercase", "media/helpers/lowercase");